import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  getAnaliseOperacao,
  getDocumentosReprovadosCliente,
  getVencimentoLimite
} from 'api/clientSearch';
import MainHeader from '../Main/MainHeader';
import LoaderMain from '../Onboarding/shared/LoaderMain';
import {
  getClienteAtual,
  removeClienteAtual,
  setClienteAtual,
  verificaClienteOnboarding,
  isAuthenticated,
  getTelaDefault,
  setRedirecionamentoRealizado,
  getRedirecionamentoRealizado
} from '../../shared';

export default props => {
  // recupera localizacao no caso de perda de sessao
  const { location: { state: { cliente } = {} } = {} } = props;
  const { location: { state: { location } = {} } = {} } = props;
  const history = useHistory();

  if (!isAuthenticated()) {
    sessionStorage.clear();
    history.push('/authentication/login');
  }

  if (cliente && cliente !== null) {
    let objCliente = getClienteAtual();

    if (typeof objCliente !== 'undefined' && objCliente !== null) {
      removeClienteAtual();
    }

    setClienteAtual(cliente);

    if (cliente.id === 'todos') {
      history.push('/');
      return null;
    }

    getAnaliseOperacao(cliente.cnpj).then(function(retAnalise) {
      var dadosAnalise = retAnalise && retAnalise.data ? retAnalise.data : {};
      var qtdOpAnalise =
        dadosAnalise && typeof dadosAnalise.qtd_operacao_analise !== 'undefined'
          ? dadosAnalise.qtd_operacao_analise
          : 0;

      // roda docs reprovados e vencimento em paralelo
      return Promise.all([
        getDocumentosReprovadosCliente(cliente.cnpj),
        getVencimentoLimite(cliente.cnpj)
      ]).then(function(arr) {
        var retDoc = arr[0];
        var retVenc = arr[1];

        var dadosDoc = retDoc && retDoc.data ? retDoc.data : {};
        var dadosVenc = retVenc && retVenc.data ? retVenc.data : {};

        var qtdReprovados =
          typeof dadosDoc.qtd_documento_reprovado !== 'undefined' ? dadosDoc.qtd_documento_reprovado : 0;

        var limiteVencendo = typeof dadosVenc.vencendo !== 'undefined' ? dadosVenc.vencendo : null;

        // mescla com o que já houver salvo para não perder outros campos
        var prev = getClienteAtual() || {};

        setClienteAtual({
          // preserva o que já existe
          ...prev,
          // garante dados-base do cliente atual
          ...cliente,
          // aplica os 3 resultados consolidados
          qtd_operacao_analise: qtdOpAnalise,
          qtd_documento_reprovado: qtdReprovados,
          limiteVencendo: limiteVencendo
        });
      });
    });

    if (cliente.id === 'todos') {
      history.push('/');
      return null;
    }

    verificaClienteOnboarding(cliente).then(verifCli => {
      if (verifCli.jornada_onboarding) {
        var urlJornada = '/jornada-onboarding';
        urlJornada += verifCli.tipo_jornada ? '-' + verifCli.tipo_jornada : '';
        if (verifCli.empresa_onboarding) {
          history.push(urlJornada);
        } else if (
          verifCli.etapaOnboarding !== undefined &&
          verifCli.etapaOnboarding.subEtapa !== 'validacao'
        ) {
          history.push(urlJornada);
        } else if (
          verifCli.etapaOnboarding !== undefined &&
          verifCli.etapaOnboarding.subEtapa === 'validacao'
        ) {
          history.push(urlJornada);
        } else {
          history.push('/');
        }
      } else {
        var possuiRotaOrigemValida =
          location && location.pathname && location.pathname !== '/grupo-empresarial';
        var redirecionar = possuiRotaOrigemValida ? location.pathname : '/';
        var telaDefault = getTelaDefault();
        let redirecionamentoRealizado = getRedirecionamentoRealizado();

        if (!possuiRotaOrigemValida && !redirecionamentoRealizado) {
          if (
            telaDefault &&
            telaDefault.tipo_chave &&
            telaDefault.tipo_chave === 'ROTA' &&
            telaDefault.chave
          ) {
            redirecionar = '/' + telaDefault.chave.replaceAll('.', '/');

            if (telaDefault.modulo !== 'plataforma_cliente') {
              redirecionar = `/${telaDefault.modulo}${redirecionar}`;
            }
            setRedirecionamentoRealizado();
          }
        }

        history.push(redirecionar);
      }
    });
  }

  return (
    <>
      <MainHeader />
      <main className="main-without-menu font-family-ibm-plex">
        <LoaderMain />
      </main>
    </>
  );
};
